import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/myframe.css';
import './assets/icons/style.css';
import './assets/css/main.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
